import { UseMutationOptions } from '@tanstack/react-query';

import type { CopyGeneratorChatState } from 'domains/content/components/CopyGeneratorChat/utils';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type GenerateCopyResponse = {
    role: 'assistant';
    content: string;
};

/**
 * Requests the next assistant turn for Ask Sara. Sends the full chat transcript and channel context.
 * @see CuredApiPaths.COPY_GENERATOR_GENERATE
 */
const useGenerateCopy = (mutateOptions?: UseMutationOptions<GenerateCopyResponse, Error, CopyGeneratorChatState>) =>
    useMutation<CopyGeneratorChatState, GenerateCopyResponse, Error>(
        MutationKeys.COPY_GENERATOR_GENERATE,
        CuredApiPaths.COPY_GENERATOR_GENERATE,
        mutateOptions
    );

export default useGenerateCopy;
